'use client';
import type { Assign } from '@ark-ui/react';
import { NumberInput } from '@ark-ui/react';
import {
  type NumberInputVariantProps,
  numberInput,
} from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(numberInput);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, NumberInput.RootProviderProps>,
    NumberInputVariantProps
  >
>(NumberInput.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, NumberInput.RootProps>,
    NumberInputVariantProps
  >
>(NumberInput.Root, 'root');

export const Control = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, NumberInput.ControlProps>
>(NumberInput.Control, 'control');

export const DecrementTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, NumberInput.DecrementTriggerProps>
>(NumberInput.DecrementTrigger, 'decrementTrigger');

export const IncrementTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, NumberInput.IncrementTriggerProps>
>(NumberInput.IncrementTrigger, 'incrementTrigger');

export const Input = withContext<
  HTMLInputElement,
  Assign<HTMLStyledProps<'input'>, NumberInput.InputProps>
>(NumberInput.Input, 'input');

export const Label = withContext<
  HTMLLabelElement,
  Assign<HTMLStyledProps<'label'>, NumberInput.LabelProps>
>(NumberInput.Label, 'label');

export const Scrubber = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, NumberInput.ScrubberProps>
>(NumberInput.Scrubber, 'scrubber');

export const ValueText = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, NumberInput.ValueTextProps>
>(NumberInput.ValueText, 'valueText');

export { NumberInputContext as Context } from '@ark-ui/react';
